var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Payment Methods" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Payment Method Availability",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "b-btn",
                            {
                              attrs: {
                                variant: "primary",
                                disabled: _vm.saving,
                              },
                              on: { click: _vm.save },
                            },
                            [
                              _vm._v(
                                "\n            Save Settings\n            "
                              ),
                              _vm.saving
                                ? _c("b-spinner", {
                                    staticClass: "ml-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { switch: "", size: "lg" },
                      model: {
                        value: _vm.achEnabled,
                        callback: function ($$v) {
                          _vm.achEnabled = $$v
                        },
                        expression: "achEnabled",
                      },
                    },
                    [_vm._v("\n          Enable ACH bank accounts\n        ")]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-muted mt-2 mb-0" }, [
                    _vm._v(
                      "\n          When disabled, users cannot add new ACH payment methods. Existing\n          payment methods and scheduled payments are not removed.\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }